import { render } from "@testing-library/react";
import { json } from "d3-fetch";
import React,{Component,useState} from "react";
import ReactDOM from 'react-dom';
import $ from 'jquery';
import './Frame.scss'

var styles = 'body{color:red;}.u-isHidden {display: none;visibility: hidden;} .iframe{position:absolute;z-index:3}';

localStorage.setItem('formComplete',false)

class Frame extends Component{
    constructor(props) {
        super(props);
        this.state = {show: true};
       
      }
      loadChange=()=>{
        if(localStorage.getItem('formComplete')=='true'){
            let timerid = setTimeout(() => {
                this.setState({show: false});
                $('.report').removeClass('blur');
              }, 1000);
        }
      }
    render(){
        return(<iframe title="form_frame" id="form_frame" src="FormsRepost/formsrepost.html" onLoad={this.loadChange} style={{ display: this.state.show ? "block" : "none" }}></iframe>)
    }

}


export default Frame;